import React from "react";
import CONFIG from "../../../../config";

import eleksnetLogo from '../../../../assets/img/where-pay/eleks-logo.svg';

const { LINKS } = CONFIG;

const EleksnetItem: React.FC = () => (
    <div className="where__pay__item yellow eleks">
        <div className="where__pay__title">
            <img src={eleksnetLogo} alt="АО НКО “Элекснет”" />
            <span>АО НКО “Элекснет”</span>
        </div>
        <div className="where__pay__link">
            <a
                href={LINKS.ELECSNET.TERMINALS}
                target="_blank"
                rel="noopener noreferrer nofollow"
            >В терминалах “Элекснет”</a>
            <p>
                <a
                    className="where__pay__instruction"
                    href={LINKS.ELECSNET.INSTRUCTION}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                >Видео инструкция</a>
            </p>
            <ul>
                <li><span>Без комиссии</span></li>
                <li><span>Моментальное зачисление платежа</span></li>
            </ul>
        </div>
        <div className="where__pay__link">
            <a href={LINKS.ELECSNET.SITE} target="_blank" rel="noopener noreferrer nofollow">На сайте 1.elecsnet.ru</a>
            <ul>
                <li><span>Комиссия 1% от суммы</span></li>
                <li><span>Моментальное зачисление платежа</span></li>
            </ul>
        </div>
    </div>
);

export default EleksnetItem;